
import React from 'react';
import ContactForm from './contactForm';
import Accordion from '../util/accordion';
import Collapsible from 'react-collapsible';

import groups from './groups';

export default class ContactUs extends React.Component {

  render() {
    return (
      <div style={{marginBottom: "10px"}}>

        <Collapsible className="main" trigger="Jewelry">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="Lost Code">
              <ContactForm 
                fields={[
                  {ref: "name", type: "text", placeholder: "Name", required: true}, 
                  {ref: "email", type: "email", placeholder: "Email", required: true}, 
                  {ref: "orderNum", type: "text", placeholder: "Order Number", required: false}, 
                  {ref: "message", type: "textarea", placeholder: "Question & Comments", required: true},
                  {ref: "subject", type: "subject", value: "Lost Code"},
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Appraisals"]} 
                groupName={"Appraisals"} />
            </div>
            <div data-trigger="Invalid Code">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "appraisalCode", type: "text", placeholder: "Appraisal Code", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Invalid Code" },
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Appraisals"]}
                groupName={"Appraisals"} />
            </div>

            <div data-trigger="Does the Jewelry in the Product Photo come with the product?">
              <p>
                We place a large variety of different styles in every product and the jewelry pictured represents just a few of the beautiful styles that you could unveil. A candle or bath bomb with a specific style of jewelry will indicate this in its description.
              </p>
            </div>
            <div data-trigger="Duplicated Jewelry">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Duplicated Jewelry" },
                ]}
                groupId={groups["Duplicated Jewelry"]}
                groupName={"General"} />
            </div>
          </Accordion>
        </Collapsible>  

        <Collapsible className="main" trigger="Damaged Product">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="Broken Upon Delivery">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Broken Upon Delivery" },
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Damaged Products"]}
                groupName={"Damaged Products"} />
            </div>
            <div data-trigger="Faulty Jewelry">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Faulty Jewelry" },
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Damaged Products"]}
                groupName={"Damaged Products"} />
            </div>
            <div data-trigger="Quality Issue">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Quality Issue" },
                ]}
                allowUploads={true}
                requireUpload={false}
                groupId={groups["Damaged Products"]}
                groupName={"Damaged Products"} />
            </div>
          </Accordion>
        </Collapsible>

        <Collapsible className="main" trigger="Cancellations & Payment Issues">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="Cancel my Order">
              <p>
                For change order requests, please indicate the item to be changed and preferred item and/or size.
              </p>
              <p>
                For address change, please include the correct address.
              </p>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Cancel my Order" },
                ]}
                groupId={groups["Payments"]}
                groupName={"Payments"} />
            </div>
            <div data-trigger="Payment Issues">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Payment Issues" },
                ]}
                groupId={groups["Payments"]}
                groupName={"Payments"} />
            </div>
          </Accordion>
        </Collapsible>

        <Collapsible className="main" trigger="Something Wrong With My Order">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="I need to edit my order">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "I need to edit my order" },
                ]}
                groupId={groups["Order Cancellation"]}
                groupName={"Order Cancellation"} />
            </div>
            <div data-trigger="I am missing items">
                <p>
                  Received an incomplete order? Gah, we're sorry! Just so we can further assist, please attach a snapshot of the shipping label sticker from the box and let us know what goodies you're sadly missing! Please note order discrepancies must be reported within 10 business days of delivery.
                </p>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "I am missing items" },
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Orders"]}
                groupName={"Orders"} />
            </div>
            <div data-trigger="Wrong items delivered">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Wrong items delivered" },
                ]}
                allowUploads={true}
                requireUpload={true}
                groupId={groups["Orders"]}
                groupName={"Orders"} />
            </div>
            <div data-trigger="Order arrived late">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Order arrived late" },
                ]}
                groupId={groups["Orders"]}
                groupName={"Orders"} />
            </div>
          </Accordion>
        </Collapsible>

        <Collapsible className="main" trigger="Shipping & Tracking">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="Where is my tracking number?">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Where is my tracking number?" },
                ]}
                groupId={groups["ShippingTracking"]}
                groupName={"ShippingTracking"} />
            </div>
            <div data-trigger="Electronic information submitted but no tracking updates (Canada only)">
              <p>
                As a cost-saving measure that we pass on directly to our customers, we use a third party courier service to transport your package to your local Canada Post distribution centre. Actual movement of the parcel begins when your parcel is dropped off at the local postal outlet. Once it arrives, your tracking number will go live and you can monitor its progress as it makes its way to you. This can take around 3-5 days depending on your location, but rest assured your order is on its way! Here’s a handy guide with estimates below:
              </p>
              <p style={{textAlign: "center"}}><img style={{maxWidth: "520px"}} src="https://cdn.shopify.com/s/files/1/0379/1505/files/shipping-table.png?10609839251938230669" /></p>
              <h2>Still Need Help?</h2>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Electronic information submitted by no tracking updates" },
                ]}
                groupId={groups["ShippingTracking"]}
                groupName={"ShippingTracking"} />
            </div>
            <div data-trigger="Carrier Delivery Issues">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Carrier Delivery Issues" },
                ]}
                groupId={groups["ShippingTracking"]}
                groupName={"ShippingTracking"} />
            </div>
          </Accordion>
        </Collapsible>

        <Collapsible className="main" trigger="General Support">
          <Accordion startPosition={20} closeable={true}>
            <div data-trigger="Ingredients/Scent Inquiry">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Ingredients/Scent Inquiry" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
            <div data-trigger="Discount Code Not Working">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Discount Code Not Working" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
            <div data-trigger="What’s my ring size?">
              <p>Use this handy guide to determine what size suits you best!</p>
              <p style={{ textAlign: "center" }}><img src="https://cdn.shopify.com/s/files/1/0379/1505/files/ring-size.png?1773584139020284070"/></p>
              <h2>Still Need Help?</h2>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "What’s my ring size?" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
            <div data-trigger="Contests & Giveaways">
              <p>
                High-value ring winners will reveal a "Winning Ticket" inside a Charmed Aroma product that contains a unique code. They will redeem the code and will receive the ring with a certificate of appraisal indicating the ring's value. For insurance purposes, these rings are sent separately. 
              </p>
              <p>
                Charmed Aroma also runs a campaign called "Surprise Sunday" where customers who purchase within a two-week timeframe are entered to win a high-valued ring featured on our homepage. High-valued rings are valued up to $5000 and come with a certificate of authenticity. 
              </p>
              <p>
                If you missed a promotion- we are so sorry to hear! You can tune in for the next promotion by signing up to our newsletter on our website or contact our customer care team for more assistance.
              </p>
              <h2>Still Need Help?</h2>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Contests & Giveaways" },
                ]}
                groupId={groups["Contests"]}
                groupName={"Contests"} />
            </div>
            <div data-trigger="Product Availability">
              <p>
                We know how sad it is to see a favourite product sell out or be retired, and we’re SO sorry for your disappointment - but don’t worry! If your favourite candle or bath bomb isn’t on our site, please let us know! Your opinion matters to us, and we would be happy to receive personal feedback from our Charmed Aroma fans. Just contact our team and we’d happy to check or help you find the next best thing!
              </p>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "orderNum", type: "text", placeholder: "Order Number", required: false },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Product Availability" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
            <div data-trigger="Wholesale & Rep Programs">
              <p>
                We currently do not offer wholesale distribution or representative programs. Although we haven’t completely shut down this idea, we have no plans in the foreseeable future to service wholesale clients. As soon as this changes, we’ll provide updates on our website and newsletter!
              </p>
            </div>
            <div data-trigger="PR Inquiries">
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "PR Inquiries" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
            <div data-trigger="Other">
              <p>
                You’ve got questions, and we have tons of answers! Ask about anything you don’t see on our contact page, as we can help! Don’t be shy - we promise we’re really nice! Additionally, you can also give us a call at (647) 691-0923. We're available Monday-Friday from 9am - 5pm EST
              </p>
              <ContactForm
                fields={[
                  { ref: "name", type: "text", placeholder: "Name", required: true },
                  { ref: "email", type: "email", placeholder: "Email", required: true },
                  { ref: "message", type: "textarea", placeholder: "Question & Comments", required: true },
                  { ref: "subject", type: "subject", value: "Other" },
                ]}
                groupId={groups["General"]}
                groupName={"General"} />
            </div>
          </Accordion>
        </Collapsible>

      </div>
    );
  }
}
